(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charities-we-support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.charities-marquee');
    if (!sections.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var track = section.querySelector('.charities-marquee__track');
      if (!track) return;

      /* ── Scroll reveal ── */
      if (reducedMotion) {
        section.classList.add('charities-marquee--visible');
      } else {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('charities-marquee--visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
        revealObserver.observe(section);
      }

      /* ── Marquee animation ── */
      if (reducedMotion) return;

      var speed = parseFloat(section.getAttribute('data-speed')) || 35;
      var cards = track.children;
      if (!cards.length) return;

      /* Calculate total width of the original set (first half) */
      var totalCards = cards.length;
      var halfCount = Math.floor(totalCards / 2);
      var setWidth = 0;

      /* Wait for images to load before measuring */
      function measureAndAnimate() {
        setWidth = 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 28;
        for (var i = 0; i < halfCount; i++) {
          setWidth += cards[i].offsetWidth + gap;
        }
        if (setWidth === 0) return;

        /* Duration based on width and speed (pixels per second) */
        var duration = setWidth / speed;

        /* Create keyframes dynamically */
        var animName = 'charities-scroll-' + section.id.replace(/[^a-zA-Z0-9]/g, '');
        var styleEl = document.createElement('style');
        styleEl.textContent =
          '@keyframes ' + animName + ' {' +
          '  0% { transform: translateX(0); }' +
          '  100% { transform: translateX(-' + setWidth + 'px); }' +
          '}';
        document.head.appendChild(styleEl);

        track.style.animation = animName + ' ' + duration + 's linear infinite';
      }

      /* Ensure images are measured */
      var images = track.querySelectorAll('img');
      var loaded = 0;
      var total = images.length;

      if (total === 0) {
        measureAndAnimate();
      } else {
        function onImgReady() {
          loaded++;
          if (loaded >= total) measureAndAnimate();
        }
        images.forEach(function (img) {
          if (img.complete) {
            onImgReady();
          } else {
            img.addEventListener('load', onImgReady);
            img.addEventListener('error', onImgReady);
          }
        });
        /* Safety: start after 3s even if images haven't loaded */
        setTimeout(function () {
          if (loaded < total) measureAndAnimate();
        }, 3000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["click-to-view-gallery"] && !Shopify.designMode) return;
  try {
    
  class clicktoviewMediaCards extends HTMLElement {
    constructor() {
      super();
      this.initSetup();
      this.initContentHeight();
      window.addEventListener('resize', this.initContentHeight.bind(this));
    }
    initSetup() {
      const wrapperSlider = this.querySelector('[clicktoview-gallery-inner-wrapper]');
      const viewportEl = this.querySelector('[clicktoview-gallery-main-wrapper]');
      const allMediaCards = this.querySelectorAll('[clicktoview-gallery-card]');
      const allMediaZoomButton = this.querySelectorAll('[clicktoview-gallery-zoom]');
      const previousButtonSlide = this.querySelector('[button-previous-nav]');
      const nextButtonSlide = this.querySelector('[button-next-nav]');
      const progressBar = this.querySelector('[media-card-progress-bar]');
      const totalSlides = allMediaCards.length;
      let currentIndex = 0;
      let maxIndex = 0;
      let maxOffsetPx = 0;
      let isAnimating = false;

      // Function to check if controls should be visible
      const shouldShowControls = () => {
        if (totalSlides <= 1) return false; // No controls needed for 0 or 1 card

        const getMainrapperWidth = wrapperSlider?.getBoundingClientRect().width || 0;
        const main_styles = window.getComputedStyle(wrapperSlider);
        const main_gap = getNumberValue(main_styles.gap || main_styles.columnGap);

        // Calculate total width of all cards with their current sizes
        let totalTrackWidth = 0;

        allMediaCards.forEach((card, idx) => {
          const cardWidth = card.getBoundingClientRect().width;
          totalTrackWidth += cardWidth;
          if (idx < totalSlides - 1) {
            totalTrackWidth += main_gap;
          }
        });
        // const slideWidthSingle = allMediaCards[0]?.getBoundingClientRect().width || 0;
        // const viewportWidth = viewportEl?.getBoundingClientRect().width || 0;
        // const slideWidthsTotal = slideWidthSingle*totalSlides;
        if (getMainrapperWidth > totalTrackWidth) {
          // this.querySelector('.clicktoview-gallery-navs').style.display='none';
          return false;
        }
        // Check if we're on mobile (you can adjust this breakpoint as needed)
        if (window.innerWidth <= 1280) {
          // On mobile, show controls only if more than 2 cards
          return totalSlides > 3;
        } else if (window.innerWidth > 1280) {
          // On desktop above 1280, show controls only if more than 3 cards
          return totalSlides > 3;
        } else {
          // For intermediate sizes (1025 to 1280), you can set a different rule or default.
          // Since the requirement doesn't specify, let's default to showing if more than 2?
          // Or we can use the same as above 1280? Let's assume we want to be consistent with desktop for now.
          return totalSlides > 3;
        }
      };

      // Function to update controls visibility
      const updateControlsVisibility = () => {
        const showControls = shouldShowControls();
        if (!showControls) {
          wrapperSlider.style.transform = `translateX(0px)`;
        }
        if (progressBar) {
          progressBar.style.display = showControls ? '' : 'none';
        }
        if (previousButtonSlide) {
          previousButtonSlide.style.display = showControls ? '' : 'none';
        }
        if (nextButtonSlide) {
          nextButtonSlide.style.display = showControls ? '' : 'none';
        }

        // updateTransform();

        // Also update ARIA attributes for accessibility
        this.setAttribute('aria-hidden', !showControls);
      };

      const getNumberValue = (val) => Number.parseFloat(String(val || '0').replace('px', '')) || 0;
      const computeLayout = () => {
        if (window.innerWidth <= 1024) {
          wrapperSlider.style.transform = `translateX(0px)`;
          return false;
        }
        // Update controls visibility first
        setTimeout(() => {
          updateControlsVisibility();
        }, 500);
        // updateControlsVisibility();
        // If controls shouldn't be shown, skip the rest of layout computation
        if (!shouldShowControls()) {
          currentIndex = 0;
          maxIndex = 0;
          if (wrapperSlider) {
            wrapperSlider.style.transform = 'translateX(0px)';
          }
          return;
        }

        // Wait for layout to settle
        requestAnimationFrame(() => {
          const slideWidthPx = allMediaCards[0]?.getBoundingClientRect().width || 0;
          const viewportWidth = viewportEl?.getBoundingClientRect().width || 0;
          const styles = window.getComputedStyle(wrapperSlider);
          const gap = getNumberValue(styles.gap || styles.columnGap);

          // Calculate total width of all cards with their current sizes
          let totalTrackWidth = 0;
          allMediaCards.forEach((card, idx) => {
            const cardWidth = card.getBoundingClientRect().width;
            totalTrackWidth += cardWidth;
            if (idx < totalSlides - 1) {
              totalTrackWidth += gap;
            }
          });

          // Calculate maxIndex based on how much we can scroll
          // maxIndex is the last position where the last card(s) are still visible
          // Since wrapper is now 100%, viewportWidth is the correct visible width
          // Calculate maximum offset: total width minus what's visible
          // This ensures the last card aligns perfectly with the right edge
          maxOffsetPx = Math.max(0, totalTrackWidth - viewportWidth);
          const visibleWidth = viewportWidth;

          // Calculate maxIndex: how far we can scroll to show all remaining cards
          // Strategy: Calculate actual pixel positions and determine max scrollable index

          if (totalTrackWidth <= visibleWidth) {
            // All cards fit, no scrolling needed
            maxIndex = 0;
          } else {
            // Calculate how many cards fit starting from position 0
            let accumulatedWidth = 0;
            let cardsThatFit = 0;

            for (let i = 0; i < totalSlides; i++) {
              const cardWidth = allMediaCards[i].getBoundingClientRect().width;
              const widthWithGap = cardWidth + (i < totalSlides - 1 ? gap : 0);
              if (accumulatedWidth + cardWidth <= visibleWidth) {
                accumulatedWidth += widthWithGap;
                cardsThatFit++;
              } else {
                break;
              }
            }

            // maxIndex should allow scrolling until we can see all remaining cards
            // Basic calculation: totalSlides - cardsThatFit
            maxIndex = Math.max(0, totalSlides - Math.max(1, cardsThatFit));

            // But we need to be more precise - check if we can actually reach the end
            // Calculate what the maximum scrollable offset would be in terms of card positions
            // The key insight: when a card expands, it takes more space, so fewer cards fit,
            // which means we need to scroll MORE positions to see all cards

            // Calculate how much offset we can actually use
            // We iterate through possible indexes and calculate their offsets
            let maxValidIndex = 0;
            for (let testIndex = 0; testIndex < totalSlides; testIndex++) {
              // Calculate offset at this index
              let testOffset = 0;
              for (let j = 0; j < testIndex; j++) {
                testOffset += allMediaCards[j].getBoundingClientRect().width + gap;
              }

              // Check if this offset would show the last card
              // Last card should be visible when: totalTrackWidth - testOffset <= visibleWidth
              if (totalTrackWidth - testOffset > visibleWidth) {
                maxValidIndex = testIndex;
              } else {
                break;
              }
            }

            // Use the maximum of both calculations to ensure we can reach all cards

            maxIndex = Math.max(maxIndex, maxValidIndex);
            maxIndex = Math.min(maxIndex, totalSlides - 1); // Cap at last index
          }

          // Ensure currentIndex doesn't exceed the new maxIndex
          currentIndex = Math.min(currentIndex, maxIndex);
          setTimeout(() => {
            updateTransform();
            updateControls();
            updateControlsVisibility();
          }, 200);
        });
      };

      const updateTransform = () => {
        // If controls shouldn't be shown, don't update transform
        if (!shouldShowControls()) {
          if (wrapperSlider) {
            wrapperSlider.style.transform = 'translateX(0px)';
          }
          return;
        }
        const styles = window.getComputedStyle(wrapperSlider);
        const gap = getNumberValue(styles.gap || styles.columnGap);

        // Calculate offset based on actual card widths (not just index * width)
        let calculatedOffset = 0;
        for (let i = 0; i < currentIndex && i < totalSlides; i++) {
          const cardWidth = allMediaCards[i]?.getBoundingClientRect().width || 0;
          calculatedOffset += cardWidth + gap;
        }

        // If we're at maxIndex, ensure we scroll enough to align the last card with the edge
        // Calculate the exact offset needed to align the last card's right edge with viewport right edge
        let finalOffset;

        if (currentIndex >= maxIndex && maxIndex > 0) {
          // At the end, calculate the exact offset to align last card with viewport edge
          // Get the last card's position relative to the track
          const lastCard = allMediaCards[totalSlides - 1];

          // Calculate where the last card starts in the track (sum of all previous cards)
          let lastCardStartPosition = 0;
          for (let i = 0; i < totalSlides - 1; i++) {
            lastCardStartPosition += allMediaCards[i].getBoundingClientRect().width + gap;
          }

          // Calculate offset needed: last card end should align with viewport end
          const lastCardWidth = lastCard?.getBoundingClientRect().width || 0;
          const lastCardEndPosition = lastCardStartPosition + lastCardWidth;
          const viewportWidth = viewportEl?.getBoundingClientRect().width || 0;
          const exactOffset = Math.max(0, lastCardEndPosition - viewportWidth);

          // Use the exact calculated offset (should match maxOffsetPx but recalculated for precision)
          finalOffset = exactOffset;
        } else {
          // Clamp to maximum offset
          finalOffset = Math.min(calculatedOffset, maxOffsetPx);
        }

        if (!isAnimating) {
          isAnimating = true;
          this._animatingStartTime = Date.now(); // Track when animation started
          wrapperSlider.classList.add('is-animating');
          const clear = () => {
            isAnimating = false;
            this._animatingStartTime = null;
            wrapperSlider.classList.remove('is-animating');
            wrapperSlider.removeEventListener('transitionend', clear);

            // After transition completes at maxIndex, recalculate exact offset to eliminate gap
            if (currentIndex >= maxIndex && maxIndex > 0) {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  const lastCard = allMediaCards[totalSlides - 1];
                  let lastCardStartPosition = 0;
                  for (let i = 0; i < totalSlides - 1; i++) {
                    lastCardStartPosition += allMediaCards[i].getBoundingClientRect().width + gap;
                  }
                  const lastCardWidth = lastCard?.getBoundingClientRect().width || 0;
                  const lastCardEndPosition = lastCardStartPosition + lastCardWidth;
                  const viewportWidth = viewportEl?.getBoundingClientRect().width || 0;
                  const exactOffset = Math.max(0, lastCardEndPosition - viewportWidth);

                  // Update transform with recalculated exact offset if different
                  // Don't trigger animation for this adjustment (it's a fine-tuning)
                  if (Math.abs(exactOffset - finalOffset) > 0.5) {
                    wrapperSlider.style.transition = 'none';
                    wrapperSlider.style.transform = `translateX(${-exactOffset}px)`;
                    // Restore transition after a frame
                    requestAnimationFrame(() => {
                      wrapperSlider.style.transition = '';
                      // Ensure controls are updated and animation state is clear
                      updateControls();
                      isAnimating = false; // Ensure animation flag is cleared
                      this._animatingStartTime = null;
                    });
                  } else {
                    // Ensure controls are updated even if no adjustment needed
                    updateControls();
                  }
                });
              });
            }
          };
          wrapperSlider.addEventListener('transitionend', clear);
        }
        // const newOffset = finalOffset - 339.6875;

        wrapperSlider.style.transform = `translateX(${-finalOffset}px)`;
        updateProgress();
        updateControls();
        setTimeout(() => {
          updateControlsVisibility();
        }, 500);
      };

      const updateProgress = () => {
        if (!progressBar || !shouldShowControls()) return;
        const progress = maxIndex === 0 ? 100 : (currentIndex / maxIndex) * 100;

        progressBar.style.setProperty('--progressbar-value', `${Math.min(100, Math.max(0, progress))}%`);
      };

      const updateControls = () => {
        // If controls shouldn't be shown, don't update their state
        if (!shouldShowControls()) return;

        const atStart = currentIndex <= 0;
        const atEnd = currentIndex >= maxIndex;
        if (previousButtonSlide) previousButtonSlide.disabled = atStart;
        if (nextButtonSlide) nextButtonSlide.disabled = atEnd;
        this.classList.toggle('at-start', atStart);
        this.classList.toggle('at-end', atEnd);
      };

      const updateExpandDirection = () => {
        const zoomedCard = this.querySelector('.clicktoview-gallery-card.zoom-in');
        allMediaCards.forEach((el) => {
          el.classList.remove('expand-open-left');
          el.classList.remove('expand-open-right');
        });
        if (!zoomedCard || !viewportEl) return;

        // Find the index of the zoomed card
        let zoomedCardIndex = -1;
        allMediaCards.forEach((card, index) => {
          if (card === zoomedCard) {
            zoomedCardIndex = index;
          }
        });

        // If it's the last slide, always expand to the left since right is already at the end
        if (zoomedCardIndex === totalSlides - 1) {
          zoomedCard.classList.add('expand-open-left');
          return;
        }

        // For other slides, determine direction based on available space
        const viewportRect = viewportEl.getBoundingClientRect();
        const cardRect = zoomedCard.getBoundingClientRect();
        const threshold = 10;
        const noRightSpace = cardRect.right > viewportRect.right - threshold;
        const noLeftSpace = cardRect.left < viewportRect.left + threshold;

        if (!noRightSpace || noLeftSpace) {
          zoomedCard.classList.add('expand-open-right');
        } else {
          zoomedCard.classList.add('expand-open-left');
        }
      };

      const autoPositionExpandedCard = (cardIndex) => {
        console.log('auto position expand card');
        const card = allMediaCards[cardIndex];
        if (!card || !viewportEl) return;
        // Special handling for last slide - ensure it aligns to right edge
        const isLastSlide = cardIndex === totalSlides - 1;
        // Wait for zoom-in class to apply and flex-basis transition to complete (0.4s)
        setTimeout(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const styles = window.getComputedStyle(wrapperSlider);
              const gap = getNumberValue(styles.gap || styles.columnGap);
              const viewportRect = viewportEl.getBoundingClientRect();
              const cardRect = card.getBoundingClientRect();
              const viewportWidth = viewportRect.width;
              const viewportRightEdge = viewportRect.right;
              const viewportLeftEdge = viewportRect.left;
              // Calculate current card position relative to viewport
              const cardRightEdge = cardRect.right;
              const cardLeftEdge = cardRect.left;
              // Check if expanded card overflows
              const overflowRight = cardRightEdge > viewportRightEdge;
              const overflowLeft = cardLeftEdge < viewportLeftEdge;
              // Calculate how much we need to adjust
              let needsReposition = false;
              let targetIndex = currentIndex;
              if (isLastSlide) {
                // For last slide, calculate exact offset to align right edge with viewport right edge
                let totalTrackWidth = 0;
                allMediaCards.forEach((c, idx) => {
                  totalTrackWidth += c.getBoundingClientRect().width;
                  if (idx < totalSlides - 1) totalTrackWidth += gap;
                });
                const exactOffset = Math.max(0, totalTrackWidth - viewportWidth);
                // Convert offset to index by finding which index gives us close to exactOffset
                let bestIndex = 0;
                let bestOffsetDiff = Infinity;
                for (let i = 0; i < totalSlides; i++) {
                  let testOffset = 0;
                  for (let j = 0; j < i; j++) {
                    testOffset += allMediaCards[j].getBoundingClientRect().width + gap;
                  }
                  const diff = Math.abs(testOffset - exactOffset);
                  if (diff < bestOffsetDiff) {
                    bestOffsetDiff = diff;
                    bestIndex = i;
                  }
                }
                targetIndex = Math.min(bestIndex, maxIndex);
                needsReposition = targetIndex !== currentIndex;
              } else if (overflowRight) {
                // Card overflows on right - calculate how many cards to shift
                const overflowAmount = cardRightEdge - viewportRightEdge;
                // Calculate actual widths up to the card position
                let cardWidthsSum = 0;
                for (let i = 0; i < cardIndex; i++) {
                  cardWidthsSum += allMediaCards[i].getBoundingClientRect().width + gap;
                }
                // Calculate how much we need to shift
                const currentOffset = cardWidthsSum;
                const neededOffset = currentOffset + overflowAmount;
                // Find which index gives us this offset
                let accumulatedWidth = 0;
                for (let i = 0; i < totalSlides; i++) {
                  if (accumulatedWidth >= neededOffset) {
                    targetIndex = i;
                    break;
                  }
                  accumulatedWidth += allMediaCards[i].getBoundingClientRect().width + gap;
                  if (i === totalSlides - 1) targetIndex = i;
                }
                targetIndex = Math.min(targetIndex, maxIndex);
                needsReposition = targetIndex !== currentIndex;
              } else if (overflowLeft) {
                // Card overflows on left - shift right to fit it
                const overflowAmount = viewportLeftEdge - cardLeftEdge;
                // Calculate actual widths up to the card position
                let cardWidthsSum = 0;
                for (let i = 0; i < cardIndex; i++) {
                  cardWidthsSum += allMediaCards[i].getBoundingClientRect().width + gap;
                }
                // Calculate how much we need to shift
                const currentOffset = cardWidthsSum;
                const neededOffset = Math.max(0, currentOffset - overflowAmount);
                // Find which index gives us this offset
                let accumulatedWidth = 0;
                for (let i = 0; i < totalSlides; i++) {
                  if (accumulatedWidth >= neededOffset) {
                    targetIndex = i;
                    break;
                  }
                  accumulatedWidth += allMediaCards[i].getBoundingClientRect().width + gap;
                }
                targetIndex = Math.max(0, targetIndex);
                needsReposition = targetIndex !== currentIndex;
              }
              // Update position if needed
              if (needsReposition) {
                console.log('needsReposition');
                currentIndex = targetIndex;
                setTimeout(() => {
                  computeLayout();
                  updateTransform();
                  updateControls();
                  updateControlsVisibility();
                }, 200);
              } else {
                setTimeout(() => {
                  updateProgress();
                  updateControlsVisibility();
                  computeLayout();
                }, 200);
              }
              // Update expand direction based on final position
              requestAnimationFrame(() => {
                updateExpandDirection();
              });
            });
          });
        }, 450); // Wait for flex-basis transition (0.4s) plus buffer
      };

      // Add event listeners for + button clicks (expand/collapse)
      allMediaZoomButton.forEach((el, index) => {
        el.addEventListener('click', () => {
          const sectionId = el.dataset.sectionId;
          const mobileCardId = el.dataset.galleryComponentId;
          const card = allMediaCards[index];
          if (window.innerWidth <= 1024) {
            card.classList.remove('zoom-in');
            // Remove expand direction classes
            allMediaCards.forEach((c) => {
              c.classList.remove('expand-open-left');
              c.classList.remove('expand-open-right');
            });
            const getDrawer = document.getElementById(`gallery-drawer-${sectionId}`);
            if (getDrawer) {
              const getAllMobileards = getDrawer.querySelectorAll('[clicktoview-gallery-card]');
              const getCurrentCardId = getDrawer.querySelector(`#${mobileCardId}`);
              getAllMobileards.forEach((c) => {
                c.classList.remove('active');
              });
              if (getCurrentCardId) {
                getCurrentCardId.classList.add('active');
              }
              getDrawer.classList.add('offcanvas-open');
            }
          } else {
            // Toggle zoom-in class on the card
            if (card.classList.contains('zoom-in')) {
              // Remove zoom-in class (collapse)
              card.classList.remove('zoom-in');
              // Remove expand direction classes
              allMediaCards.forEach((c) => {
                c.classList.remove('expand-open-left');
                c.classList.remove('expand-open-right');
              });

              setTimeout(() => computeLayout(), 200);
            } else {
              // Remove zoom-in from all cards first
              allMediaCards.forEach((c) => {
                c.classList.remove('zoom-in');
                c.classList.remove('expand-open-left');
                c.classList.remove('expand-open-right');
              });
              // Add zoom-in to clicked card (expand)
              card.classList.add('zoom-in');

              // Auto-position the expanded card and set expand direction
              autoPositionExpandedCard(index);
              // Also recalculate layout after expansion settles
              // setTimeout(() => computeLayout(), 450); // After flex-basis transition (0.4s)
            }
          }
        });
      });

      const onPrev = () => {
        if (currentIndex <= 0 || !shouldShowControls()) return;

        // Collapse any zoomed cards when navigating
        allMediaCards.forEach((el) => {
          el.classList.remove('zoom-in');
        });

        // If isAnimating is stuck (longer than 1 second), clear it
        // Or if we're at maxIndex and want to go back, allow it (animation likely finished but flag stuck)
        if (isAnimating) {
          const animatingSince = Date.now() - (this._animatingStartTime || Date.now());
          const isAtEnd = currentIndex >= maxIndex;

          if (animatingSince > 1000 || isAtEnd) {
            // Clear stuck animation or allow at end
            isAnimating = false;
            this._animatingStartTime = null;
            wrapperSlider.classList.remove('is-animating');
          } else if (animatingSince > 200) {
            // Allow navigation after initial animation start (200ms)
            isAnimating = false;
            this._animatingStartTime = null;
            wrapperSlider.classList.remove('is-animating');
          } else {
            return; // Still in early animation phase, wait briefly
          }
        }

        currentIndex -= 1;
        updateTransform();
        updateControls();
      };

      const onNext = () => {
        // If controls shouldn't be shown, don't allow navigation
        if (!shouldShowControls()) return;

        // Collapse any zoomed cards when navigating
        allMediaCards.forEach((el) => {
          el.classList.remove('zoom-in');
        });

        // If isAnimating is stuck (longer than 1 second), clear it
        if (isAnimating) {
          const animatingSince = Date.now() - (this._animatingStartTime || Date.now());
          if (animatingSince > 1000) {
            isAnimating = false;
            this._animatingStartTime = null;
            wrapperSlider.classList.remove('is-animating');
          } else {
            return; // Still animating, wait
          }
        }
        if (currentIndex >= maxIndex) return;
        currentIndex += 1;

        // If we're about to reach maxIndex, ensure layout recalculates after transition
        const willReachMax = currentIndex >= maxIndex;

        updateTransform();
        updateControls();

        // If we reached maxIndex, recalculate layout after transition to eliminate gap
        if (willReachMax) {
          setTimeout(() => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                // Ensure animation flag is cleared before recalculating
                isAnimating = false;
                this._animatingStartTime = null;
                wrapperSlider.classList.remove('is-animating');
                computeLayout();
                // Force update controls after layout recalculation
                updateControls();
              });
            });
          }, 600); // Wait for transform transition to complete
        }
      }; 


      previousButtonSlide?.addEventListener('click', onPrev);
      nextButtonSlide?.addEventListener('click', onNext);
      computeLayout();
      const resizeObserver = new ResizeObserver(() => {
        setTimeout(() => {
          computeLayout();
        }, 500);
      });
      if (viewportEl) {
        resizeObserver.observe(viewportEl);
      }
      window.addEventListener('resize', computeLayout);
      document.addEventListener('shopify:section:load', updateControlsVisibility());
    }
    initContentHeight() {
      const allMediaCards = this.querySelectorAll('[clicktoview-gallery-card]');
      const isMobile = window.innerWidth <= 1024;
      if(isMobile){
          // Remove expand direction classes
        allMediaCards.forEach(card => {
            card.classList.remove(
              'zoom-in',
              'expand-open-left',
              'expand-open-right'
            );
          });

      }
      allMediaCards.forEach((card, idx) => {
        const getContentInner = card.querySelector('[data-clicktoview-content-inner]');
        const getContent = card.querySelector('[data-clicktoview-hidden-content]');
        if (getContent && getContentInner) {
          const getContentHeight = getContent.getBoundingClientRect().height;
          getContentInner.style.setProperty('--hidden-content--height', `${getContentHeight}px`);
        }
      });
    }
  }
  customElements.define('clicktoview-gallery-story', clicktoviewMediaCards);

  class ClickToViewGalleryDrawer extends HTMLElement {
    constructor() {
      super();

      // Select elements
      this.cards = Array.from(this.querySelectorAll('[clicktoview-gallery-card]'));
      this.nextButton = this.querySelector('[button-next-nav]');
      this.prevButton = this.querySelector('[button-previous-nav]');
      this.closeButton = this.querySelector('[data-offcanvas-close]');
      this.activeClass = 'active';

      // Bind methods
      this.close = this.close.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handlePrev = this.handlePrev.bind(this);

      // Setup listeners
      this.attachEventListeners();

      window.addEventListener('resize', () => this.toggleDrawerResize());
    }

     toggleDrawerResize(){
        const isDesktop = window.innerWidth > 1024;
        if(isDesktop){
          this.close();
        }
      }

    attachEventListeners() {
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);
      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.closeButton) this.closeButton.addEventListener('click', this.close);
    }

    get currentIndex() {
      return this.cards.findIndex((card) => card.classList.contains(this.activeClass));
    }

    setActiveCard(newIndex) {
      // Handle empty state gracefully
      if (this.cards.length === 0) return;

      // Normalize index to loop around
      const index = (newIndex + this.cards.length) % this.cards.length;

      // Update active class
      this.cards.forEach((card, i) => card.classList.toggle(this.activeClass, i === index));

      const activeCard = this.cards[index];
      if (activeCard) {
        const getCardMainId = activeCard.dataset.cardId;
        if (getCardMainId) {
          document.getElementById(`${getCardMainId}`).scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      }
    }

    handleNext() {
      this.setActiveCard(this.currentIndex + 1);
    }

    handlePrev() {
      this.setActiveCard(this.currentIndex - 1);
    }

    close(e) {
      if (e) e.preventDefault();
      this.classList.remove('offcanvas-open');
    }
  }

  customElements.define('clicktoview-gallery-drawer', ClickToViewGalleryDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class AccordionDetails extends HTMLDetailsElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');
      this._open = this.hasAttribute('open');
      this.summaryElement = this.querySelector('summary');
      this.contentElement =
        this.querySelector('summary + *') || this.querySelector('.footer-menu-list') || this.querySelector('.rte');
      this.setAttribute('aria-expanded', this._open ? 'true' : 'false');

      this.shouldOpenOnMobile = this.hasAttribute('data-mobile-accordion-open');
      this.defaultOpenOnMobile = this.dataset.mobileAccordionOpen === 'true';
      this.mobileAccordionVisibility = this.dataset.mobileAccordionVisibility; // New line
      // this.isMobile = window.innerWidth <= 768;

      this.mediaQuery = window.matchMedia(`(min-width: 768px)`);
      this.isMobile = !this.mediaQuery.matches;

      this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', () => {
          this.open = true;
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.open = false;
        });
      }

      // only run once per element (even in editor)
      if (this.shouldOpenOnMobile && !this.dataset.initOnce) {
        this.applyMobileDefaultState();
        this.dataset.initOnce = 'true'; // prevent re-trigger
      }

      window.addEventListener('resize', this.onResize.bind(this));
    }

    get designModeActive() {
      return true;
    }

    get controlledElement() {
      return this.closest('accordions-details');
    }

    static get observedAttributes() {
      return ['open'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'open') {
        this.setAttribute('aria-expanded', newValue === '' ? 'true' : 'false');
      }
    }

    get open() {
      return this._open;
    }

    set open(value) {
      if (value !== this._open) {
        this._open = value;

        if (this.isConnected) {
          this.transition(value);
        } else {
          value ? this.setAttribute('open', '') : this.removeAttribute('open');
        }
      }

      this.setAttribute('aria-expanded', value ? 'true' : 'false');
      this.dispatchEventHandler();
    }

    async onSummaryClick(event) {
      event.preventDefault();

      // If on mobile and visibility is 'all', then do not close on click
      if (this.isMobile && this.mobileAccordionVisibility === 'all') {
        return; 
      }

      // If we are opening this, first close any other open accordions in the same section
      if (!this.open && this.section && this.mobileAccordionVisibility !== 'all') {
        const openAccordions = Array.from(
          this.section.querySelectorAll('details[is="accordion-details"][open]')
        ).filter((el) => el !== this);

        if (openAccordions.length) {
          await Promise.all(openAccordions.map((el) => el.close()));
        }
        this.open = true;
      } else if(this.mobileAccordionVisibility !== 'all') {
        this.open = !this.open;
      }
    }

    close() {
      this._open = false;
      return this.transition(false);
    }

    transition(value) {
      this.style.overflow = 'hidden';

      // Update dimensions dynamically
      const summaryHeight = this.summaryElement.clientHeight;
      const contentHeight = this.contentElement ? this.contentElement.scrollHeight : 0;

      if (value) {
        this.setAttribute('open', '');

        const startHeight = `${summaryHeight}px`;
        const endHeight = `${summaryHeight + contentHeight}px`;

        return new Promise((resolve) => {
          this.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease' }).onfinish = () => {
            this.style.height = 'auto';
            this.style.overflow = 'visible';
            resolve();
          };
        });

        if (this.contentElement) {
          this.contentElement.style.opacity = 1;
          this.contentElement.style.transform = 'translateY(0)';
        }
      } else {
        const startHeight = `${this.clientHeight}px`;
        const endHeight = `${summaryHeight}px`;
        return new Promise((resolve) => {
          this.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease' }).onfinish = () => {
            this.removeAttribute('open');
            this.style.height = 'auto';
            this.style.overflow = 'visible';
            resolve();
          };
        });

        if (this.contentElement) {
          this.contentElement.animate(
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(10px)'] },
            { duration: 150, easing: 'ease' }
          ).onfinish = () => {
            this.contentElement.style.opacity = 0;
          };
        }
      }
    }

    onResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      // Only run logic if the attribute exists
      if (!this.shouldOpenOnMobile) return;

      // If state changed between mobile and desktop
      if (this.isMobile !== wasMobile) {
        if (this.isMobile) {
          this.applyMobileDefaultState();
        } else {
          this.open = true; // On desktop, always open
        }
      }
    }

    applyMobileDefaultState() {
      if (this.isMobile) {
        const accordions = Array.from(this.section.querySelectorAll('details[is="accordion-details"]'));
        const currentAccordionIndex = accordions.indexOf(this);

        if (this.mobileAccordionVisibility === 'first') {
          this.open = currentAccordionIndex === 0;
        } else if (this.mobileAccordionVisibility === 'all') {
          this.open = true;
        } else if (this.mobileAccordionVisibility === 'none') {
          this.open = false;
        }
      } else {
        this.open = true; // Always open on desktop
      }
    }

    dispatchEventHandler() {
      (this.controlledElement ?? this).dispatchEvent(
        new CustomEvent('toggle', { bubbles: true, detail: { current: this } })
      );
    }
  }

  customElements.define('accordion-details', AccordionDetails, { extends: 'details' });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.hamburgerWrapper = null;
    this.headerMenuDrawer = null;
    this.mediaQuery = window.matchMedia('(min-width: 1025px)');
    this.boundHandleMediaChange = this.handleMediaChange.bind(this);
  }

  connectedCallback() {
    this.childlinkLinks = this.querySelectorAll('[data-nav-childlink-link]');
    this.childlinkLinksBack = this.querySelectorAll('[data-mobile-childlink-back]');
    
    this.initChildLinksClick();

    this.hamburgerWrapper = this.querySelector('[data-hamburger-Wrapper]');
    this.headerMenuDrawer = document.querySelector('hamburger-drawer-tabs');

    this.closeButton = this.querySelector('[data-offcanvas-close]');
    this.headerMenuDrawerTrigger = document.querySelector('[data-mobile-drawer-button]');

    if (this.headerMenuDrawerTrigger) {
      this.headerMenuDrawerTrigger.addEventListener('click', () => this.openDrawer());
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeDrawer());
    }

    if (this.hamburgerWrapper && this.headerMenuDrawer) {
      this.initHamburger();
    }

    // ✅ Listen for desktop/mobile switch
    this.mediaQuery.addEventListener('change', this.boundHandleMediaChange);
    this.handleMediaChange(this.mediaQuery);

    this.hamburgerDrawer();
    if (Shopify.designMode) {
      this.observeDesignMode();
    }
  }
  observeDesignMode() {
  
    this.addEventListener('shopify:section:load', this.showHamburger);
    this.addEventListener('shopify:section:unload', this.hideHamburger);
    this.addEventListener('shopify:section:select', this.showHamburger);
    this.addEventListener('shopify:section:deselect', this.hideHamburger);
  }

  showHamburger = () => {
    this.toggleHamburger(false);

  };

  hideHamburger = () => {
    this.toggleHamburger(true);

  };
  toggleHamburger(hide = true) {
    const nav = document.querySelector('[data-hamburger-nav]');
    const button = document.querySelector('[data-hamburger-button-wrapper]');
    if (!nav || !button) return;

    nav.classList.toggle('hidden', hide);
    button.classList.toggle('hidden', hide);
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.boundHandleMediaChange);
  }
  hamburgerDrawer() {
    this.querySelectorAll('[data-main-hamburger]').forEach(tabsContainer => {
      const tabButtons = tabsContainer.querySelectorAll('[data-link-hamburger]');
      const tabContents = tabsContainer.querySelectorAll('[data-block-hamburger]');

      const activateTab = (button) => {
        const targetId = button.getAttribute('data-tab');
        const targetContent = tabsContainer.querySelector(`#${targetId}`);
        if (!targetContent) return;

        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => {
          content.classList.remove('active');
          // If the element is empty (no child nodes or text)
          const isEmpty = !content.innerHTML.trim();
          if (isEmpty) {
            content.classList.add('no-subdata');
          } else {
            content.classList.remove('no-subdata'); // Optional: clean up if previously added
          }
        });


        button.classList.add('active');
        targetContent.classList.add('active');
      };

      tabButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          activateTab(button);
        });

        button.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateTab(button);
          }
        });
        // button.addEventListener('focus', () => {
        //   activateTab(button);
        // });
      });
    });

    
    // Global click handlers
    this.addEventListener('click', (e) => {
      const navLink = e.target.closest('[data-nav-hamburger-link]');
      const backButton = e.target.closest('[data-hamburger-back]');

      if (navLink) {
        const mainParent = navLink.closest('[data-hamburger-nav]');
        const parent = navLink.closest('[data-hamburger-megamenu-item]');
        const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
        if (mainParent && parent && siblings) {
          mainParent.classList.add('hamburger-megamenu-menus-open');
          siblings.forEach(item => item.classList.remove('active'));
          parent.classList.add('active');
          const focusElement = parent.querySelector('.hamburger-megamenus-menuswrap');
          // if (focusElement) {
          //   trapFocus(focusElement);
          // }
        }
      }

      if (backButton) {
        const mainParent = backButton.closest('[data-hamburger-nav]');
        document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
          item.classList.remove('active');
        });
        if (mainParent) {
          mainParent.classList.remove('hamburger-megamenu-menus-open');
        }
      }
    });
  }

  openDrawer() {
    this.classList.add('mobile-menu-open');
    document.body.classList.add('overflow-hidden');
  }

  closeDrawer() {
    this.classList.remove('mobile-menu-open');
    document.body.classList.remove('overflow-hidden');
  }

  handleMediaChange(e) {
    if (e.matches) {
      // >=1025px desktop
      this.closeDrawer();
    } else {
      // <1025px mobile
      if (this.hamburgerWrapper && this.headerMenuDrawer) {
        this.initHamburger();
      }
    }
  }

  initChildLinksClick() {
    this.childlinkLinks.forEach(childlink => {
      childlink.addEventListener('click', (e) => {
        e.preventDefault();
        const clickedMenu = childlink.closest('[data-child-menu]');
        if (clickedMenu) clickedMenu.classList.toggle('active-submenu');
      });
    });

    this.childlinkLinksBack.forEach(childlinkBack => {
      childlinkBack.addEventListener('click', (e) => {
        e.preventDefault();
        const clickedMenu = childlinkBack.closest('[data-child-menu]');
        if (clickedMenu) clickedMenu.classList.remove('active-submenu');
      });
    });
  }

  initHamburger() {
    const checkVisibility = this.headerMenuDrawer.getAttribute('data-visibility-on');
    if (checkVisibility === 'desktop') return;

    const template = this.headerMenuDrawer.querySelector('template');
    if (!template) return;

    this.hamburgerWrapper.innerHTML = '';
    const clone = template.content.cloneNode(true);

    // const navWithAttr = clone.querySelector('[data-hamburger-nav]');
    // if (navWithAttr) navWithAttr.removeAttribute('data-hamburger-nav');

    // const navWithColor = clone.querySelector('[data-color-scheme]');
    // if (navWithColor) {
    //   navWithColor.classList.remove('hamburger-nav');
    //   navWithColor.classList.add('hamburger-mobilenav');
    //   const colorClass = navWithColor.getAttribute('data-color-scheme');
    //   if (colorClass) navWithColor.classList.remove(colorClass);
    // }

    this.hamburgerWrapper.appendChild(clone);
    this.hamburgerWrapper.classList.remove('hidden');

    // Add submenu toggles for hamburger menu
    this.hamburgerChildLink = this.querySelectorAll('[data-nav-hamburger-link]');
    this.hamburgerChildLinkBack = this.querySelectorAll('[data-hamburger-back]');

    if (this.hamburgerChildLink) {
      this.hamburgerChildLink.forEach(childlink => {
        childlink.addEventListener('click', (e) => {
          // e.preventDefault();
          const mainParent = childlink.closest('.hamburger-mobilenav');
          const parent = childlink.closest('[data-hamburger-megamenu-item]');
          const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
          if (mainParent && parent && siblings) {
            mainParent.classList.add('hamburger-megamenu-menus-open');
            siblings.forEach(item => item.classList.remove('active'));
            parent.classList.add('active');
          }
        });
      });
    }

    if (this.hamburgerChildLinkBack) {
      this.hamburgerChildLinkBack.forEach(childlinkBack => {
        childlinkBack.addEventListener('click', (e) => {
          e.preventDefault();
          const mainParent = childlinkBack.closest('.hamburger-mobilenav');
          document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
            item.classList.remove('active');
          });
          if (mainParent) {
            mainParent.classList.remove('hamburger-megamenu-menus-open');
          }
        });
      });
    }

    this.hamburgerDrawer();
  }
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);


class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.container = this.dataset.headerContainer;
  } 

  connectedCallback() {
    this.header = document.querySelector('.header-section');
    const menuDrawerContainer = document.querySelector('[data-menu-drawer-container]');
    if (menuDrawerContainer && this.container) {
      menuDrawerContainer.className = menuDrawerContainer.className.replace(/\bcontainer(?:-[^\s]+)?\b/g, '').trim();
      menuDrawerContainer.classList.add(this.container);
    }
    this.setHeaderHeight();
    if (!this.getAttribute('data-sticky-type')){
      document.body.classList.add('sticky-header-none');
      return;
    } 
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

    this.headerBounds = {};

   

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    window.addEventListener('resize', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.classList.add('header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.headerTop = 1000;
    this.predictiveSearch = this.querySelector('predictive-search');

    
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    // this.headerNavigation();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerTop) {
      this.classList.add('transparent-none');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerTop) {
      this.classList.add('transparent-none');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.classList.remove('transparent-none');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.classList.add('header-hidden', 'header-sticky');
    document.body.classList.add('header-ishidden');
    // this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.classList.add('header-sticky', 'animate');
    this.classList.remove('header-hidden');
    document.body.classList.remove('header-ishidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.classList.remove('header-hidden', 'header-sticky', 'animate');
    document.body.classList.remove('header-ishidden');
  }


  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }

}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-blocks"] && !Shopify.designMode) return;
  try {
    
  class DotsAnimator extends HTMLElement {
    constructor() {
      super();
      this.config = {
        sx: 2,
        sy: 1.5,
        tx: 0,
        ty: 0,
      };
      this.targets = [
        { sx: [0.385, 1.53], sy: [0.9, 0.9], tx: [-30.72, 26.64], ty: [-5, 0] },
        { sx: [0.67, 1.238], sy: [0.9, 0.9], tx: [-63.76, 61.68], ty: [-5, 0] },
        { sx: [0.96, 0.96], sy: [0.9, 0.9], tx: [-74.22, 74.22], ty: [-5, 0] },
        { sx: [1.238, 0.67], sy: [0.9, 0.9], tx: [-61.68, 63.76], ty: [-5, 0] },
        { sx: [1.53, 0.385], sy: [0.9, 0.9], tx: [-26.64, 30.72], ty: [-5, 0] },
      ];
      this.easingFactor = 8;
      this.mouse = [0, 0];
      this.current = { el: null, id: null };
      this.state = {};
      this.hasAnimatedId = null; // intersection active ellipse id
    }

    connectedCallback() {
      this.init();
      document.addEventListener('mousemove', this.onMouseMove.bind(this));
      document.addEventListener('mouseover', this.onMouseOver.bind(this));
      document.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.animate();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    init() {
      const elements = this.querySelectorAll('[data-elipse-animate]');
      elements.forEach((el, i) => {
        const id = `mask${i}`;
        const svg = this.createSVG(id);
        el.appendChild(svg);
        this.state[id] = {
          container: el,
          svg: svg,
          actual: this.initialState(),
          faded: this.initialState(),
        };

        // Reset current hover on mouse leave from element
        el.addEventListener('mouseleave', () => {
          if (this.current.el === el) {
            this.resetCurrent();
            this.current.el = null;
            this.current.id = null;
          }
        });
      });

      // Intersection observer to track viewport entry/exit
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const el = entry.target;
            const svg = el.querySelector('svg');
            if (!svg) return;
            const id = svg.id;

            if (entry.isIntersecting) {
              // Only activate if no other intersection active
              if (!this.hasAnimatedId) {
                this.hasAnimatedId = id;
                this.activateEllipse(id);
              }
            } else if (this.hasAnimatedId === id) {
              // Smooth reset when element leaves viewport
              this.resetEllipse(id);
              this.hasAnimatedId = null;
            }
          });
        },
        { threshold: 0.5 }
      );

      elements.forEach((el) => this.observer.observe(el));
    }

    onMouseMove(e) {
      this.mouse = [e.clientX || this.mouse[0], e.clientY || this.mouse[1]];

      if (this.current.el) {
        const rect = this.current.el.getBoundingClientRect();
        const progress = this.ease(Math.abs((this.mouse[0] - rect.left) / this.current.el.offsetWidth));

        const target = this.state[this.current.id];
        for (let i = 0; i < target.actual.length; i++) {
          const shape = target.actual[i];
          const t = this.targets[i];
          shape.sx = t.sx[0] + (t.sx[1] - t.sx[0]) * progress;
          shape.sy = t.sy[0];
          shape.tx = t.tx[0] + (t.tx[1] - t.tx[0]) * progress;
          shape.ty = t.ty[0];
        }
      }
    }

    onMouseOver(e) {
      const dot = e.target.closest('[data-elipse-animate]');
      if (!dot) {
        this.resetCurrent();
        this.current.el = null;
        this.current.id = null;
        return;
      }

      const svg = dot.querySelector('svg');
      const newId = svg ? svg.id : null;

      // Reset viewport active ellipse if different from hovered
      if (this.hasAnimatedId && this.hasAnimatedId !== newId) {
        this.resetEllipse(this.hasAnimatedId);
        this.hasAnimatedId = null;
      }

      // Reset previous hover ellipse if different from new hover
      if (this.current.el && this.current.el !== dot) {
        this.resetCurrent();
      }

      this.current.el = dot;
      this.current.id = newId;
      document.dispatchEvent(new Event('mousemove')); // update animation immediately
    }

    onMouseLeave(e) {
      // Smoothly reset the current hovered ellipse
      this.resetCurrent();
      this.current.el = null;
      this.current.id = null;
    }

    animate() {
      for (const id in this.state) {
        const { svg, actual, faded } = this.state[id];
        for (let i = 0; i < faded.length; i++) {
          const target = actual[i];
          const current = faded[i];
          current.sx += (target.sx - current.sx) / this.easingFactor;
          current.sy += (target.sy - current.sy) / this.easingFactor;
          current.tx += (target.tx - current.tx) / this.easingFactor;
          current.ty += (target.ty - current.ty) / this.easingFactor;
          if (svg.children[i + 1]) {
            svg.children[
              i + 1
            ].style.transform = `translate(${current.tx}%, ${current.ty}%) scale(${current.sx}, ${current.sy})`;
          }
        }
      }
      requestAnimationFrame(this.animate.bind(this));
    }

    ease(t) {
      return (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
    }

    initialState() {
      return Array(5)
        .fill()
        .map(() => ({
          sx: this.config.sx,
          sy: this.config.sy,
          tx: this.config.tx,
          ty: this.config.ty,
        }));
    }

    activateEllipse(id) {
      const target = this.state[id];
      if (!target) return;
      for (let i = 0; i < target.actual.length; i++) {
        const shape = target.actual[i];
        const t = this.targets[i];
        shape.sx = t.sx[1];
        shape.sy = t.sy[0];
        shape.tx = t.tx[1];
        shape.ty = t.ty[0];
      }
    }

    resetEllipse(id) {
      if (!id || !this.state[id]) return;
      const target = this.state[id];
      for (let i = 0; i < target.actual.length; i++) {
        target.actual[i].sx = this.config.sx;
        target.actual[i].sy = this.config.sy;
        target.actual[i].tx = this.config.tx;
        target.actual[i].ty = this.config.ty;
      }
    }

    resetCurrent() {
      if (!this.current.id) return;
      this.resetEllipse(this.current.id);
    }

    createSVG(id) {
      const svg = this.createSVGElement('svg', {
        viewBox: '0 0 100 100',
        preserveAspectRatio: 'none',
        id: id,
        class: 'mask',
      });

      svg.appendChild(
        this.createSVGElement('rect', {
          width: '100%',
          height: '100%',
          fill: 'transparent',
        })
      );

      const positions = [13.75, 32, 50, 68, 86];
      positions.forEach((cx) => {
        const ellipse = this.createSVGElement('ellipse', {
          cx: cx,
          cy: '51',
          rx: '12.5',
          ry: '50',
          fill: 'black',
        });
        ellipse.style.transform = `translate(${this.config.tx}%, ${this.config.ty}%) scale(${this.config.sx}, ${this.config.sy})`;
        svg.appendChild(ellipse);
      });

      return svg;
    }

    createSVGElement(tag, attrs) {
      const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
      for (let attr in attrs) {
        el.setAttribute(attr, attrs[attr]);
      }
      return el;
    }
  }

  customElements.define('xs-elipse-animator', DotsAnimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class MainPassword extends HTMLElement {
    constructor() {
      super();
      this.passwordButton = document.querySelector('[data-password]');
      this.passwordDrawer = document.querySelector('[data-offcanvas-password]');
    }
    connectedCallback() {
      if (this.passwordButton) {
        this.passwordButton.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            this.open();
          }.bind(this)
        );
      }
      this.setupCloseListeners();
    }
    open() {
      this.passwordDrawer.classList.add('offcanvas-open');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        this.trapFocus(this.passwordDrawer);
      }, 500);
    }
    setupCloseListeners() {
      const closeButtons = [
        document.querySelector('[data-offcanvas-close]'),
        document.querySelector('[offcanvas-close]'),
      ];

      closeButtons.forEach((btn) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
      });
    }
    close() {
      this.passwordDrawer.classList.remove('offcanvas-open');
      document.body.classList.remove('overflow-hidden');
    }
    trapFocus(container) {
      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'textarea:not([disabled])',
        'input:not([type="hidden"])',
        'select:not([disabled])',
        'summary',
        '[tabindex]:not([tabindex="-1"])',
      ];

      const isVisible = (el) => {
        if (!el) return false;

        // Walk up all parents
        let node = el;
        while (node && node !== document.body) {
          const style = window.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' || node.hidden) {
            return false;
          }
          node = node.parentElement;
        }
        return true;
      };
      const focusableEls = Array.from(container.querySelectorAll(focusableSelectors.join(','))).filter(isVisible);
      const firstEl = focusableEls[0];
      const lastEl = focusableEls[focusableEls.length - 1];

      if (!firstEl) return; // nothing to trap

      // focus the first focusable element
      firstEl.focus();

      const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            // shift + tab
            if (document.activeElement === firstEl) {
              e.preventDefault();
              lastEl.focus();
            }
          } else {
            // tab
            if (document.activeElement === lastEl) {
              e.preventDefault();
              firstEl.focus();
            }
          }
        }
        // Escape closes trap (optional)
        // if (e.key === 'Escape') {
        //   container.classList.remove('active');
        //   document.removeEventListener('keydown', handleKeyDown);
        // }
      };

      document.addEventListener('keydown', handleKeyDown);
    }
  }
  if (!customElements.get('main-password')) {
    customElements.define('main-password', MainPassword);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reveal-images"] && !Shopify.designMode) return;
  try {
    
  class StackCards extends HTMLElement {
    constructor() {
      super();

      this.items = [];
      this.scrollingFn = null;
      this.scrolling = false;
      this.marginY = 0;
      this.elementHeight = 0;
      this.cardTop = 0;
      this.cardHeight = 0;
      this.windowHeight = 0;

      this._intersectionObserver = null;
      this._resizeTimeout = null;

      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onIntersection = this._onIntersection.bind(this);
      this._onFocusIn = this._onFocusIn.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-stack-slide]'));
      if (this.items.length === 0) return;
      // Respect reduced motion
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Refined IntersectionObserver
      if ('IntersectionObserver' in window) {
        this._intersectionObserver = new IntersectionObserver(this._onIntersection, {
          root: null,
          rootMargin: '0px 0px -40% 0px', // trigger earlier/later
          threshold: 0.1, // start when 10% is visible
        });
        this._intersectionObserver.observe(this);
      }

      window.addEventListener('resize', this._onResize, { passive: true });
      this.addEventListener('focusin', this._onFocusIn);

      this.Imagestyle = this.getAttribute('data-images-style');

      this._setStackCards();
    }

    disconnectedCallback() {
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
      }
      window.removeEventListener('resize', this._onResize);
      this.removeEventListener('focusin', this._onFocusIn);
      this._removeScrollListener();
    }

    _onIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this._addScrollListener();
          this._animateStackCards(); // run immediately on enter
        } else {
          this._removeScrollListener();
          this.items.forEach((item) => item.classList.remove('is-focused'));
        }
      });
    }

    _addScrollListener() {
      if (!this.scrollingFn) {
        this.scrollingFn = this._onScroll;
        window.addEventListener('scroll', this.scrollingFn, { passive: true });
      }
    }

    _removeScrollListener() {
      if (this.scrollingFn) {
        window.removeEventListener('scroll', this.scrollingFn);
        this.scrollingFn = null;
      }
    }

    _onScroll() {
      if (!this.scrolling) {
        this.scrolling = true;
        window.requestAnimationFrame(() => this._animateStackCards());
      }
    }

    _onResize() {
      clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(() => {
        this._setStackCards();
        this._animateStackCards();
      }, 250);
    }

    _setStackCards() {
      let marginYValue = getComputedStyle(this).getPropertyValue('--stack-cards-gap');
      this.marginY = this._parseCssSizeToPx(marginYValue.trim());

      this.elementHeight = this.offsetHeight;

      if (this.items.length > 0) {
        const cardStyle = getComputedStyle(this.items[0]);
        this.cardTop = Math.floor(parseFloat(cardStyle.getPropertyValue('top'))) || 0;
        this.cardHeight = Math.floor(parseFloat(cardStyle.getPropertyValue('height'))) || 0;
      }

      this.windowHeight = window.innerHeight;

      this.style.paddingBottom = isNaN(this.marginY) ? '0px' : `${this.marginY * (this.items.length - 1)}px`;

      this.items.forEach((item, i) => {
        if (!isNaN(this.marginY)) {
          item.style.transform = `translateY(${this.marginY * i}px)`;
        } else {
          item.style.transform = 'none';
        }
        item.classList.remove('is-focused');
      });
    }

    _parseCssSizeToPx(value) {
      if (!value) return NaN;
      if (value.endsWith('px')) return parseInt(value);
      if (value.endsWith('rem') || value.endsWith('em')) return parseFloat(value) * 16;
      return NaN;
    }

    _animateStackCards() {
      if (isNaN(this.marginY)) {
        this.scrolling = false;
        return;
      }

      const top = this.getBoundingClientRect().top;

      // Stop animating if we're out of range
      if (
        this.cardTop -
          top +
          this.windowHeight -
          this.elementHeight -
          this.cardHeight +
          this.marginY +
          this.marginY * this.items.length >
        0
      ) {
        this.scrolling = false;
        return;
      }

      const minScale = 0.6;
      const maxScale = 1;

      this.items.forEach((item, i) => {
        const scrolling = this.cardTop - top - i * (this.cardHeight + this.marginY);
        if (scrolling > 0) {
          let scaling = i === this.items.length - 1 ? maxScale : (this.cardHeight - scrolling * 0.15) / this.cardHeight;

          // Keep scale between min and max
          scaling = Math.max(minScale, Math.min(maxScale, scaling));

          // Also keep Y offset so they appear stacked
          const translateY = this.marginY * i;
          if (this.Imagestyle == 'contain') {
            item.style.transform = `translateY(${translateY}px) scale(${scaling})`;
          } else {
            item.style.transform = `translateY(${translateY}px)`;
          }
        } else {
          item.style.transform = `translateY(${this.marginY * i}px) scale(${maxScale})`;
        }
      });

      this.scrolling = false;
    }
    
    _onFocusIn(event) {
        const focusedItem = event.target.closest('[data-stack-slide]');
        if (!focusedItem) return;

        this.items.forEach((item) => item.classList.remove('is-focused'));
        focusedItem.classList.add('is-focused');

        const get_offsettop = focusedItem.offsetTop;
        const itemRect = focusedItem.getBoundingClientRect();
        const get_height = itemRect.height / 2;
        const i = this.items.indexOf(focusedItem);
          const getnew = get_height + this.marginY * i

          const isLast = focusedItem === this.items[this.items.length - 1];
          const isBackward = event.shiftKey === true;
          
          if (isBackward) {
            // Align focused card like manual scroll: compute delta from current viewport to sticky top
            const containerTop = this.getBoundingClientRect().top; // viewport y for component
            const stickyTop = this.cardTop || 0; // same top used by sticky items
            const targetTopInViewport = focusedItem.getBoundingClientRect().top; // current top of focused card
            const delta = targetTopInViewport - (containerTop + stickyTop);

            // Scroll by the exact delta so focused card lands at sticky anchor
            window.scrollBy({ top: delta, behavior: 'smooth' });

            // After scroll progresses, run the same animation step as manual scrolling
            const handleScrollProgress = () => {
              if (!this.scrolling) {
                this.scrolling = true;
                window.requestAnimationFrame(() => this._animateStackCards());
              }
            };
            window.addEventListener('scroll', handleScrollProgress, { once: true, passive: true });

            // Fallback to ensure animation runs even if no scroll event fires
            setTimeout(() => {
              handleScrollProgress();
            }, 200);
          } else {
            if(isLast){
              window.scrollTo({
                  top: get_offsettop,
                  behavior: 'smooth',
                });
            }else{
              window.scrollTo({
                top: get_offsettop - getnew,
                behavior: 'smooth',
              });
          }
          }
        this._animateStackCards();

      }

  }

  customElements.define('stack-cards', StackCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reveal-shop"] && !Shopify.designMode) return;
  try {
    

  class SectionIntroAnimation extends HTMLElement {
    constructor() {
      super();
  
      this.holder = this;
      this.container = this.holder.querySelector('[data-section-container]');
      this.introHeader = this.holder.querySelector('[data-intro-header]');
      this.introInner = this.holder.querySelector('[data-scroll-inner]');
      
      this.introFooter = this.holder.querySelector('[data-intro-footer]');
      this.firstImageBlock = this.holder.querySelector('[data-first-image]');
      this.firstImageBlockScale = this.holder.querySelector('[data-intro-image]');
      this.secondImageBlock = this.holder.querySelector('[data-second-image]');
      this.secondImage = this.secondImageBlock?.querySelector('[data-image]');
      this.transitionProgress = { value: 0 };
      this.section = this.closest('section');
      this.pin = this.section.querySelector('[data-section-pin]');
  
      this.stickyOffset = this.section.offsetTop;
  
      this.tl = null;
      this.mediaQuery = window.matchMedia('(min-width: 768px)');
      this.prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  
      if (this.shouldRunAnimations()) {
        this.init();
      }
  
      this.mediaQuery.addEventListener('change', (e) => {
        if (e.matches && this.shouldRunAnimations()) {
          this.init();
        } else {
          this.kill();
        }
      });
  
      this.prefersReduced.addEventListener('change', (e) => {
        if (e.matches) {
          this.kill();
        } else if (this.mediaQuery.matches) {
          this.init();
        }
      });

      const inEditor = typeof Shopify !== 'undefined' && Shopify.designMode;
      if (inEditor) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        document.addEventListener('shopify:section:unload', this.onSectionUnload);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      }

    }
  
    shouldRunAnimations() {
      return this.mediaQuery.matches && !this.prefersReduced.matches;
    }
  
    init() {
      this.kill();
      this.tl = this.getAnimation();
      if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
        ScrollTrigger.refresh();
      }
    }
  
    kill() {
      if (this.tl) {
        if (this.tl.scrollTrigger) this.tl.scrollTrigger.kill();
        this.tl.kill();
        this.tl = null;
      }
  
      if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.getAll) {
        ScrollTrigger.getAll().forEach((st) => {
          if (st.trigger === this.pin) st.kill();
        });
      }
  
      if (typeof gsap !== 'undefined' && gsap.set) {
        gsap.set(
          [
            this.introHeader,
            this.introFooter,
            this.firstImageBlock,
            this.firstImageBlockScale,
            this.secondImageBlock,
            this.secondImage
          ].filter(Boolean),
          { clearProps: 'all' }
        );
      }
  
      this.section.classList.remove('sticky');
    }
  
    getAnimation() {
      if (typeof gsap === 'undefined') return null;
      if (typeof ScrollTrigger !== 'undefined' && gsap.registerPlugin) {
        gsap.registerPlugin(ScrollTrigger);
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.pin,
          start: 'top top',
          end: () => {
            const h = this.pin ? this.pin.scrollHeight : 0;
            return h > 0 ? `+=${h}` : '100%';
          },
          scrub: 2.5,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          pinSpacing: true 
        }
      });
  
      const introHeaderAnim = gsap.fromTo(
        this.introHeader,
        { yPercent: 0 },
        { 
          yPercent: -100,
          duration: 1.5,
          ease: 'none'
         }
      );
  
      // const introInnerAnim = gsap.fromTo(
      //   this.introInner,
      //   { yPercent: 0 },
      //   { yPercent: -120, duration: 1.5, ease: 'none' }
      // );
  
      const introFooterAnim = gsap.fromTo(
        this.introFooter,
        { yPercent: 0 },
        { yPercent: -170, duration: 1.5, ease: 'none' }
      );
  
      gsap.set(this.firstImageBlock, { x: 0 });
  
      const firstImageAnim = gsap.fromTo(
        this.firstImageBlock,
        { x: () => {
            const containerW = this.section.getBoundingClientRect().width || 0;
            const elW = this.firstImageBlock?.getBoundingClientRect().width || containerW;
            return Math.min(containerW, elW) * 0.5; // start half-width to the right
          }
        },
        { x: 0, duration: 4.5, ease: 'none' }
      );
  
      const firstImageBlockScaleAnmi = gsap.fromTo(
        this.firstImageBlockScale,
        { scale: 1 },
        { scale: 0.8, duration: 4.5, ease: 'none' }
      );
  
      const secondImageBlockAnim = this.secondImageBlock
        ? gsap.fromTo(
            this.secondImageBlock,
            {
              x: () => {
                const containerW = this.section.getBoundingClientRect().width || 0;
                const elW = this.secondImageBlock?.getBoundingClientRect().width || containerW;
                return Math.min(containerW, elW) * 0.5;
              },
              scale: 0.8
            },
            { x: 0, scale: 1, duration: 4.5, ease: 'none' }
          )
        : null;
  
      const secondImageAnim = this.secondImage
        ? gsap.fromTo(
            this.secondImage,
            { x: () => {
                const containerW = this.section.getBoundingClientRect().width || 0;
                const elW = this.secondImage?.getBoundingClientRect().width || containerW;
                return Math.min(containerW, elW) * 0.5;
              }
            },
            { x: 0, duration: 4.5, ease: 'none' }
          )
        : null;
  
      tl.add(introHeaderAnim)
        .add(introFooterAnim,'<')
        .add(firstImageAnim, '<')
        .add(firstImageBlockScaleAnmi, '<');
  
      if (secondImageBlockAnim) tl.add(secondImageBlockAnim, '<');
      if (secondImageAnim) tl.add(secondImageAnim, '<');
  
      return tl;
    }

    onSectionLoad = (event) => {
      if (!event.target.contains(this)) return;
      requestAnimationFrame(() => {
        if (this.shouldRunAnimations()) {
          this.init();
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) ScrollTrigger.refresh();
        } else {
          this.kill();
        }
      });
    };

    onSectionUnload = (event) => {
      if (!event.target.contains(this)) return;
      this.kill();
    };

    onSectionSelect = (event) => {
      if (!event.target.contains(this)) return;
      requestAnimationFrame(() => {
        if (this.shouldRunAnimations()) {
          this.init();
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) ScrollTrigger.refresh();
        }
      });
    };

    onSectionDeselect = (event) => {
      if (!event.target.contains(this)) return;
      this.kill();
    };
  
    createRevealTimeline(container, target, section) {
      const { width } = section.getBoundingClientRect();
      const tl = gsap.timeline();
  
      const pointerEventsOff = gsap.fromTo(target, { pointerEvents: 'all' }, { pointerEvents: 'all', duration: 1 });
  
      const clipExpand = gsap.fromTo(
        container,
        { '--corner-clip': 0 },
        {
          '--corner-clip': `${1.5 * width}px`,
          duration: 1.5,
          ease: 'none',
          onUpdate: () => {
            const value = parseFloat(gsap.getProperty(container, '--corner-clip'));
            if (container.querySelector('[data-collections-list]')) {
              const productList = container.querySelector('[data-collections-list]');
              if (value > 50) productList.classList.add('revealed');
              else productList.classList.remove('revealed');
            }
          }
        }
      );
  
      const translateX = gsap.fromTo(
        container,
        { '--corner-clip-x': 100, '--xpx': '0px' },
        { '--corner-clip-x': 0, '--xpx': `${width}px`, duration: 1.5 }
      );
  
      return tl.add(pointerEventsOff).add(clipExpand, '<').add(translateX);
    }
  }
  customElements.define('xs-reveal-shop', SectionIntroAnimation);

  // Observe content size changes inside pinned section to refresh ScrollTrigger
  (function(){
    try {
      const el = document.querySelector('xs-reveal-shop');
      if (!el || typeof ResizeObserver === 'undefined' || typeof ScrollTrigger === 'undefined') return;
      const ro = new ResizeObserver(() => {
        if (ScrollTrigger && ScrollTrigger.refresh) ScrollTrigger.refresh();
      });
      ro.observe(el);
    } catch (e) {}
  })();
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  class TimelineSection extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.contents = [];
      this.images = [];
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-timeline-button]');
      this.contents = this.querySelectorAll('[data-timeline-content]');
      this.images = this.querySelectorAll('[data-media]');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.switchTab(btn.dataset.tab));
      });
    }

    switchTab(tabId) {
      // Remove active state from all
      this.buttons.forEach((b) => b.classList.remove('active'));
      this.contents.forEach((c) => c.classList.add('hidden'));
      this.images.forEach((img) => img.classList.add('hidden'));

      // Activate clicked tab
      const activeBtn = this.querySelector(`[data-tab="${tabId}"]`);
      const activeContent = this.querySelector(`#${tabId}`);
      const activeImage = this.querySelector(`[data-media="${tabId}"]`);

      if (activeBtn) activeBtn.classList.add('active');
      if (activeContent) activeContent.classList.remove('hidden');
      if (activeImage) activeImage.classList.remove('hidden');
    }
  }

  customElements.define('timeline-section', TimelineSection);

  } catch(e) { console.error(e); }
})();
})();
